import { APIMethod, fetchData } from "@client";

export async function editTeamMemberQuery(
  userUuid,
  teamRole,
  professionalLevel,
  technicalStack,
  projectsVisibility
) {
  const data = {
    userUuid,
    teamRole,
    professionalLevel,
    stackType: technicalStack.length ? `[${technicalStack.join(",")}]` : "[]",
  };

  if (projectsVisibility !== undefined) {
    data.projectsVisibility = projectsVisibility;
  }
  
  const res = await fetchData("/team", APIMethod.PUT, {
    data,
    removeEmptyKeys: true,
    mapRequestKeysToSnakeCase: false,
  });
  return res.results;
}
